import { type InsuranceCorporateIdentity } from "../types";

export function KronesLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M177.474 157.179L159.439 169.56C159.223 169.718 159.066 169.946 159.017 170.224C158.968 170.48 159.026 170.758 159.184 170.985C185.872 209.556 199.977 255.034 199.977 302.503C199.977 349.753 185.872 395.142 159.193 433.781C159.046 434 158.987 434.268 159.026 434.535C159.076 434.802 159.233 435.039 159.449 435.197L177.464 447.816C177.699 447.984 178.004 448.045 178.289 447.965C178.575 447.896 178.81 447.709 178.948 447.442L249.896 302.959C250.035 302.673 250.035 302.335 249.896 302.049L178.948 157.565C178.82 157.307 178.575 157.11 178.301 157.03C178.015 156.961 177.71 157.009 177.474 157.179Z"
        fill="white"
      />
      <path
        d="M335.34 64.0088C335.054 64.0472 334.787 64.2169 334.629 64.4633L246.169 199.219C245.991 199.487 245.951 199.824 246.06 200.12L299.347 352.315C299.436 352.604 299.653 352.82 299.93 352.93C300.206 353.039 300.513 353.02 300.78 352.88L320.305 342.562C320.541 342.444 320.73 342.226 320.799 341.968C320.888 341.711 320.858 341.434 320.73 341.197C298.792 299.547 290.231 252.727 295.985 205.807C301.769 158.669 321.393 115.235 352.74 80.2201C352.929 80.012 353.017 79.7447 352.997 79.4775C352.988 79.199 352.858 78.9525 352.662 78.7749L336.152 64.2569C335.925 64.0584 335.637 63.9704 335.34 64.0088Z"
        fill="white"
      />
    </svg>
  );
}

export const Krones: InsuranceCorporateIdentity = {
  id: "krones",
  name: "Krones",
  logo: KronesLogo,
  backgroundColor: "#2F51A3",
  textColor: "#FFFFFF",
  wildcard: "krones",
  type: "statutory",
};
